import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
let BaseFileInput = class BaseFileInput extends Vue {
    constructor() {
        super(...arguments);
        this.file = null;
        this.localFileName = this.fileName;
    }
    onFileNameChanged(newValue) {
        this.localFileName = newValue;
    }
    get fileLabel() {
        return this.attachment || this.label;
    }
    get attachment() {
        return this.localFileName || this.currentFile;
    }
    get inputLabel() {
        return !this.attachment ? '' : this.label.replace('\t', '');
    }
    get currentFileUrl() {
        if (this.file) {
            return URL.createObjectURL(this.file);
        }
        return this.fileAttachmentUrl;
    }
    viewFile(fileUrl, fileName) {
        fetch(fileUrl)
            .then((response) => response.blob())
            .then((blob) => {
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = fileName;
            a.click();
            URL.revokeObjectURL(url);
        });
    }
    getMimeType(fileExtension) {
        switch (fileExtension.toLowerCase()) {
            case 'pdf':
                return 'application/pdf';
            case 'jpg':
            case 'jpeg':
                return 'image/jpeg';
            case 'png':
                return 'image/png';
            case 'doc':
            case 'docx':
                return 'application/msword';
            case 'xls':
            case 'xlsx':
                return 'application/vnd.ms-excel';
            case 'ppt':
            case 'pptx':
                return 'application/vnd.ms-powerpoint';
            default:
                return 'application/octet-stream';
        }
    }
    onFileChange(file) {
        if (file) {
            this.$emit('file:changed', file);
            this.file = file;
        }
    }
    removeFile() {
        this.$emit('remove-file');
        this.clearFile();
    }
    clearFile() {
        this.file = null;
        this.$refs[this.id].value = '';
        this.localFileName = '';
        this.$emit('update:fileName', '');
    }
};
__decorate([
    Prop({ type: String, default: null })
], BaseFileInput.prototype, "fileName", void 0);
__decorate([
    Prop({ type: String, required: true })
], BaseFileInput.prototype, "label", void 0);
__decorate([
    Prop({ type: String, default: '' })
], BaseFileInput.prototype, "currentFile", void 0);
__decorate([
    Prop({ type: String, default: null })
], BaseFileInput.prototype, "fileAttachmentUrl", void 0);
__decorate([
    Prop({ type: String, default: 'file' })
], BaseFileInput.prototype, "id", void 0);
__decorate([
    Prop({ type: Array, default: null })
], BaseFileInput.prototype, "errorMessages", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], BaseFileInput.prototype, "isUploading", void 0);
__decorate([
    Prop({ type: String, default: 'image/*, .doc, .docx, .pdf, .epub' })
], BaseFileInput.prototype, "fileTypes", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], BaseFileInput.prototype, "remove", void 0);
__decorate([
    Watch('fileName')
], BaseFileInput.prototype, "onFileNameChanged", null);
BaseFileInput = __decorate([
    Component
], BaseFileInput);
export default BaseFileInput;
